// 図面のマーカーをセンサー種別で塗り分けるための色。
// 凡例と図面のマーカーが同じ値を参照する必要があるため、両者の親ディレクトリに置く。
import { SENSOR_TYPES } from '@/mixins/sensorTypes';

// R 型設置場所に登録できないセンサー種別が渡された場合に使う。
const DEFAULT_MARKER_COLOR = '#FFD700';

export const MARKER_COLORS = {
  [SENSOR_TYPES.RAT]: '#FFD700',
  [SENSOR_TYPES.RAT_SENSE]: '#73E3FF',
};

export const markerColorFor = sensorType => MARKER_COLORS[sensorType] || DEFAULT_MARKER_COLOR;
